import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { getConf } from '@jbrowse/core/configuration';
import { linearWiggleDisplayModelFactory } from '@jbrowse/plugin-wiggle';
import { types } from 'mobx-state-tree';
/**
 * #stateModel LinearGCContentDisplay
 * base model BaseWiggleDisplayModel
 */
export default function stateModelFactory(pluginManager, configSchema) {
  return types.compose('LinearGCContentDisplay', linearWiggleDisplayModelFactory(pluginManager, configSchema), types.model({
    /**
     * #property
     */
    type: types.literal('LinearGCContentDisplay')
  })).views(function (self) {
    var superRenderProps = self.renderProps;
    return {
      /**
       * #method
       * retrieves the sequence adapter from parent track, and puts it as a
       * subadapter on a GCContentAdapter
       */
      renderProps: function renderProps() {
        var sequenceAdapter = getConf(self.parentTrack, 'adapter');
        return _objectSpread({}, superRenderProps(), {
          adapterConfig: {
            type: 'GCContentAdapter',
            sequenceAdapter: sequenceAdapter
          }
        });
      }
    };
  });
}